<script>
import {mapState} from "vuex"
import SearchTopBar from "@/components/global/SearchTopBar"
import AdminSearchResults from "@/components/global/AdminSearchResults"
import _ from "underscore"
import IncidentModal from "@/components/global/IncidentModal"
import Config from "@/config"

export default {
  components: {
    SearchTopBar,
    AdminSearchResults,
    IncidentModal,
  },
  data() {
    return {
      debug: false,
      displayName: "Asset Type Search",
      collapseRows: true,
      cellCap: 2,
      assetTypes: [],
      filters: [
        {
          id: "assetTypeTextSearch",
          type: "text",
          value: "",
          cols: 6,
        },
        {
          id: "createIncidentButton",
          type: "button",
          value: "",
          label: "Create Incident",
          cols: 2,
          variant: "light",
        },
      ],
      sortBy: "assetTypeId",
      sortDesc: false,
    }
  },
  computed: {
    ...mapState("auth", ["role", "email"]),
    incidentGroup() {
      return Config.itar.incidentGroup
    },
    results() {
      return {
        fields: [
          {key: "assetTypeId", label: "Asset Type ID", sortable: true},
          {key: "assetTypeName", label: "Asset Type Name", sortable: true},
          {key: "assetTypeDesc", label: "Asset Type Description", sortable: true},
        ],
        records: this.assetTypes,
      }
    },
  },
  created() {
    this.initialSearch()
  },
  methods: {
    async initialSearch() {
      try {
        const assetTypes = await this.$store.dispatch("asset/getAssetTypes")
        console.log(assetTypes)
        this.assetTypes = assetTypes.map(assetType => ({
          assetTypeId: assetType.assetTypeId,
          assetTypeName: assetType.assetTypeName,
          assetTypeDesc: assetType.assetTypeDesc,
        }))
      } catch (error) {
        console.error("Error fetching asset type data:", error)
      }
    },
    async filterChange(data) {
      if (this.debug) console.log("[AssetTypeSearch.vue] filterChange:", data)
      if (data.id === "assetTypeTextSearch") {
        this.searchText = data.val
      }
    },
    async filterOnClick(data) {
      if (this.debug) console.log("[AssetTypeSearch.vue] filterOnClick:", data)
      if (data.id === "assetTypeTextSearch" && data.val === "submit") {
        // Filter asset types  when enter is pressed
        const searchText = this.searchText?.toLowerCase() || ""
        const assetTypes = await this.$store.dispatch("asset/getAssetTypes")
        this.assetTypes = assetTypes
          .filter(assetType => assetType.assetTypeName?.toLowerCase().includes(searchText))
          .map(assetType => ({
            assetTypeId: assetType.assetTypeId,
            assetTypeName: assetType.assetTypeName,
            assetTypeDesc: assetType.assetTypeDesc,
          }))
      } else if (data.id === "assetTypeTextSearch" && data.val === "reset") {
        // Reset the search when reset is clicked
        this.searchText = ""
        await this.initialSearch()
      }
    },
    buttonOnClick(id) {
      console.log(id)
      if (this.debug) console.log("buttonOnClick:", id)
      if (id == "createIncidentButton") {
        if (this.email == "") {
          this.$store.dispatch("auth/retrieveEmail")
        }
        this.$bvModal.show("createIncidentModal")
      }
    },
    onRowClick(data) {
      if (data && data.assetTypeId) {
        this.$router.push({
          path: `/assettypes/details/${data.assetTypeId}`,
        })
      }
    },
  },
}
</script>

<template>
  <div id="AssetTypeSearch">
    <SearchTopBar
      :filters="filters"
      @filterChange="filterChange"
      @filterClick="filterOnClick"
      @buttonClick="buttonOnClick"
    />
    <div class="PageContent">
      <AdminSearchResults
        :fields="results.fields"
        :records="results.records"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        :collapseRows="collapseRows"
        :cellCap="cellCap"
        @onRowClick="onRowClick"
      />
    </div>
    <IncidentModal
      :group="incidentGroup"
      :displayName="displayName"
    />
  </div>
</template>
